// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__22KRa","itemA":"Write_itemA__h4lln","itemB":"Write_itemB__3i8XH","itemC":"Write_itemC__2iHum","itemD":"Write_itemD__3HSvv"};